/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .happ-button-list[_ngcontent-%COMP%]{background:#fff;margin:5px;font-size:14px;padding:5px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block;line-height:14px!important}"];
export { styles as styles };
